export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT'
export const REMOVE_ALL_ALERTS = 'REMOVE_ALL_ALERTS'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'
export const LOAD_USER = 'LOAD_USER'
export const AUTH_FAILED ='AUTH_FAILED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOG_OUT = 'LOG_OUT'
export const ADD_AMOUNT_SUCCESS = 'ADD_AMOUNT_SUCCESS'
export const ADD_AMOUNT_FAIL = 'ADD_AMOUNT_FAIL'
export const SET_FUTURE_ESTIMATE_SUCCESS = 'SET_FUTURE_ESTIMATE_SUCCESS'
export const SET_FUTURE_ESTIMATE_FAIL = 'SET_FUTURE_ESTIMATE_FAIL'
//For commit 2